module.exports = __webpack_public_path__ + "img/pmaktif.c6872ce4.png";